// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__CevsG","sidePaddings":"MainLayout_sidePaddings__I8aCR","pageContent":"MainLayout_pageContent__QYunG","content":"MainLayout_content__HkA76"};